module.exports = __webpack_public_path__ + "static/mpost44.5454d3a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost44.jpg
// module id = 253
// module chunks = 35783957827783 269829036549620